/**
 * プロジェクトの名前の変更の日本語（en.projectName.ts と同じキーを全部持つ。漏れは typecheck で落ちる）。表記の決め事は ja.ts の冒頭と同じ。
 * 例の名前（"Booking App"・2026-09-30 までは "Sky Racers"）と語（"Kumo"・"Support"・"Security"）は訳さない: 判定は英字の語で行われる（サーバーの isReservedProjectName）ため、
 * 訳すと「どの語が当たるのか」が分からなくなる。
 */
import type { enProjectName } from './en.projectName';

type ProjectNameMessages = { [K in keyof typeof enProjectName]: string };

export const jaProjectName: ProjectNameMessages = {
  'projectName.title': 'プロジェクト名',
  'projectName.lead':
    'この名前は、利用者に届くメールの件名と差出人名に表示されます。公開する前に分かりやすい名前を決めてください。URLの名前（URLの「neko-jump」のような部分）は別の設定で、こちらを変えてもURLは変わりません。',
  'projectName.label': '名前',
  'projectName.count': '{count}/{max}',
  'projectName.tooLong': '{max}文字以内にしてください。',
  'projectName.save': '保存',
  'projectName.saving': '保存中…',
  'projectName.renamed': '名前を「{old}」から「{new}」に変えました。',
  'projectName.unchanged': '名前はすでに「{name}」です。変更はありません。',
  'projectName.error.rateLimited': '名前の変更が多すぎます。変更は1時間に20回までです。しばらくしてからもう一度お試しください。',
  'projectName.error.accountClosed': 'このアカウントは閉鎖されているため、プロジェクト名は変えられません。',
  'projectName.error.invalid': '名前は1〜{max}文字にしてください。',
  'projectName.error.generic': '名前を変えられませんでした。少し待ってからもう一度お試しください。',

  'error.name_reserved':
    'この名前は {product} や運営スタッフのように見えるため、メールに表示されると利用者を誤解させるおそれがあります。「KUMO」という語を含む名前や、「Support」「Security」のような語だけでできた名前は使えません。「Booking App」のように、プロジェクトそのものの名前を付けてください。'
};
